// /var/www/afra/192.testproject.work/maracar8/0.8.2/myapp/src/components/DataQueues/EventDialogServiceTimeSidebar/PaymentMethodContainer.js

import { useState, useEffect } from 'react';
import { Col } from 'react-bootstrap';
import { InputSwitch, InputText } from 'primereact';
import { getSelectedLanguage } from '../../../api/api';
import { languageManager } from '../../../utils/loadLanguage';

const PaymentMethodContainer = ({
  paymentMethodGroup2, 
  handlePaymentMethodChangeGroup2,
  paymentAmount,
  handlePaymentAmountChange,
  handleInputFocus,
  handleInputBlur,
  paymentPercentage,
  handlePaymentPercentageChange
}) => {

  const [translations, setTranslations] = useState({});

  useEffect(() => {
    async function loadLang() {
      const lang = getSelectedLanguage();
      await languageManager.loadLanguage(lang);
      setTranslations(languageManager.translations);
    }
    loadLang();
  }, []);

  return (
    <>
      <h4>{translations.paymentMethodContainer?.label || "Select Payment Method"}</h4>

      <div className="p-field-horizontal">
        <label htmlFor="online" className="payment-label">{translations.paymentMethodContainer?.online || "Online"}</label>
        <InputSwitch checked={paymentMethodGroup2 === 'online'} onChange={() => handlePaymentMethodChangeGroup2('online')} />
      </div>
      <div className="p-field-horizontal">
        <label htmlFor="store" className="payment-label">{translations.paymentMethodContainer?.inStore || "In-Store"}</label>
        <InputSwitch checked={paymentMethodGroup2 === 'store'} onChange={() => handlePaymentMethodChangeGroup2('store')} />
      </div>
      <div className="p-field-horizontal">
        <label htmlFor="paymentAmount" className="payment-label">{translations.paymentMethodContainer?.paymentAmount || "Payment Amount"}</label>
        <InputText id="paymentAmount" value={paymentAmount} onFocus={handleInputFocus} onBlur={handleInputBlur} onChange={(e) => handlePaymentAmountChange(e.target.value)} />
      </div>
      <h4>{translations.paymentMethodContainer?.labelPercentage || "Select Payment Percentage"}</h4>


      <div className="p-field-horizontal">

        <label htmlFor="halfPayment" className="payment-label">{translations.paymentMethodContainer?.halfPayment || "50% Payment"}</label>
        <InputSwitch  className="custom-input-switch"checked={paymentPercentage === 'half'} onChange={() => handlePaymentPercentageChange('half')} />

        <label htmlFor="fullPayment" className="payment-label">{translations.paymentMethodContainer?.fullPayment || "100% Payment"}</label>
        <InputSwitch className="custom-input-switch" checked={paymentPercentage === 'full'} onChange={() => handlePaymentPercentageChange('full')} />

        <label htmlFor="NotPayment" className="payment-label">{translations.paymentMethodContainer?.notPayment || "Not Payment"}</label>
        <InputSwitch className="custom-input-switch" checked={paymentPercentage === 'notPayment'} onChange={() => handlePaymentPercentageChange('notPayment')} />

        
      </div>

    </>
  );
};

export default PaymentMethodContainer;
